import * as React from 'react';
import { useIntl } from 'react-intl';
import { useRecoilState, useRecoilValue } from 'recoil';
import { autofocusAtom, isRidePlayerOpenAtom, vehicleFocusAtom } from '../OnlineMapState';
import { rideAutofocusAtom } from '../../RidePlayer/RidePlayerState';
import useAnalytics from '../../../hooks/useAnalytics';

export default function AutoFocusControl(): JSX.Element {
  const { formatMessage: f } = useIntl();
  const [autofocus, setAutofocus] = useRecoilState<boolean>(autofocusAtom);
  const [vehicleFocus, setVehicleFocus] = useRecoilState<boolean>(vehicleFocusAtom);
  const isRidePlayerOpen = useRecoilValue<number | boolean>(isRidePlayerOpenAtom);
  const [rideAutofocus, setRideAutofocus] = useRecoilState<boolean>(rideAutofocusAtom);
  const { trackEvent } = useAnalytics();

  const handleChangeAutoFocus = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    event.preventDefault();
    trackEvent(['map', 'click', 'Focus on selected vehicles']);

    if (!rideAutofocus && isRidePlayerOpen && vehicleFocus && !autofocus) {
      setVehicleFocus(false);
    }

    if (isRidePlayerOpen) {
      setRideAutofocus(!rideAutofocus);
    }
    if (vehicleFocus && !isRidePlayerOpen) {
      setVehicleFocus(false);
    }
    if (!isRidePlayerOpen) {
      setAutofocus(!autofocus);
    }
  };

  return (
    <a
      onClick={handleChangeAutoFocus}
      title={f({ id: 'map.autofocus.control' })}
      data-cy="controls-on-map-autofocus"
      className={`${autofocus || rideAutofocus ? 'e-button-sq text-primary' : 'e-button-sq'}`}
    >
      <i className="cmd-icons cmd-icon-zoom-in-map" />
    </a>
  );
}
